import type { AddToBasketMutation, Product } from '@packages/gql/generated/shopping/graphql';
import { unmask } from '@packages/gql/src/betterMasking';
import type { LineItemFragmentFragmentDoc } from '@packages/gql/generated/shopping/LineItemFragmentFragmentDoc';

export const getProductFromLineItems = (
  lineItems: AddToBasketMutation['addToBasket']['lineItems'],
  sku: Product['sku'],
) => {
  const potentialProductFromLineItems = lineItems[lineItems.length - 1];

  // check if the last item of linItems matches the given sku
  if (potentialProductFromLineItems.product.sku === sku) {
    return unmask<typeof LineItemFragmentFragmentDoc>(potentialProductFromLineItems);
  }
  // otherwise find a product with the given sku in lineItems
  return unmask<typeof LineItemFragmentFragmentDoc>(
    lineItems.find((lineItem) => lineItem.product.sku === sku),
  );
};
